import React from 'react';
import {
  Box,
  Flex,
  Container,
  Link,
  useBreakpointValue,
  Image,
  Button,
  IconButton,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { AUTH_PROVIDERS, useAuthProvider } from './Authentication/AuthProviderSwitch';
import Navigation from './Navigation';
import assets from './assets';

const Header = () => {
  const { isAuthenticated, user, logout, provider } = useAuthProvider();
  const showMobileNav = useBreakpointValue({ base: true, lg: false });

  const handleLogout = () => {
    if (!logout) return;
    if (provider === AUTH_PROVIDERS.AUTH0) {
      logout({ returnTo: window.location.origin });
      return;
    }
    logout();
  };

  return (
    <Box
      as="header"
      bgGradient="linear(to-b, gray.50, white)"
      position="fixed"
      w="100%"
      zIndex="1000"
    >
      <Container maxW="container.xl">
        <Flex justify="space-between" align="center" py={4}>
          {/* Logo on the left */}
          <Link as={RouterLink} to="/">
            <Image
              src={assets.teliviLogo}
              h={{ base: '64px', md: '80px' }}
              alt="Telivi IT"
            />
          </Link>

          {/* Navigation and Auth section grouped together on the right */}
          <Flex align="center" gap={4}>
            {showMobileNav ? (
              <Menu>
                <MenuButton
                  as={IconButton}
                  aria-label="Open navigation menu"
                  icon={<HamburgerIcon />}
                  variant="outline"
                />
                <MenuList>
                  <MenuItem as={RouterLink} to="/">
                    Home
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/platforms">
                    Platforms
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/pricing">
                    Pricing
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/how-it-works">
                    How It Works
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/security">
                    Security
                  </MenuItem>
                  <MenuItem as={RouterLink} to="/contact">
                    Contact
                  </MenuItem>
                  <MenuItem as={RouterLink} to={isAuthenticated ? "/client/account" : "/client/login"}>
                    Client Portal
                  </MenuItem>
                  {!isAuthenticated ? (
                    <MenuItem as={RouterLink} to="/login">
                      Login
                    </MenuItem>
                  ) : null}
                </MenuList>
              </Menu>
            ) : (
              <Navigation />
            )}

            {isAuthenticated ? (
              <Menu>
                <MenuButton
                  as={Button}
                  rounded="full"
                  variant="link"
                  cursor="pointer"
                  minW={0}
                >
                  <Avatar
                    size="sm"
                    src={user?.avatarUrl}
                    name={user?.name}
                    bg="blue.500"
                    color="white"
                  />
                </MenuButton>
                <MenuList>
                  <MenuItem>
                    <Text fontWeight="semibold">{user?.name || user?.email}</Text>
                  </MenuItem>
                  <MenuItem
                    icon={<FaSignOutAlt />}
                    onClick={handleLogout}
                  >
                    Sign Out
                  </MenuItem>
                </MenuList>
              </Menu>
            ) : null}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Header;
